import {defineStore} from 'pinia';

export const useInfoStore = defineStore({
    id: 'user_info',
    state: () => ({
        count: 0,
        groupKey: '',
        baseInfo: {},
        showTeacherLogin: false,
        newsScore: false,
        loading: false,
        landingIndex: 0,
        backUrl: '',
        backType: 0
    }),
    actions: {
        setKey(key, value) {
            this[key] = value;
        },
        changeAlert(flag,groupKey){
            this.groupKey = groupKey
        },

        landingRefresh() {
            this.landingIndex++;
        },
    },
    persist: true
});

